

export class CostReviewWiringInterlocks {
  boilerChillerWiringDetailed!: number;
  flowSwitchesWiredBy!: string;
  chemicalFeedSystemWiringRequired!: number;
  sumpLevelControllerWiringRequired!: number;
  splitSystemDxWiringRequired!: number;
  exhaustFanWiring!: number;
  exhaustFanDamperInterlocks!: number;
  coolingTowerWiring!: number[];
  panelPowerWiredBy!: number;
  smokeDetectorsInstalledBy!: number;
  smokeDetectorsFurnishedBy!: number;
  interlocks120Volt!: number;
  smokeDetectorsLocatedBy!: number;
  siemensPanelsPoweredBy!: number;
  isWiringInterlocksApplicable!: boolean;
  other!: string;
}
